<template>
    <div>
        <avue-crud
                :option="option"
                :data="data"
                :page="page"
                @refresh-change="refreshChange"
                @search-change="searchChange"
                @row-save="store"
                @row-update="update"
                @row-del="del"
                @size-change="sizeChange"
                @current-change="currentChange"
                :upload-before="uploadBefore"
                ref="crud"
        >
            <template slot="menuLeft">
                <el-button size="small" icon="el-icon-download" type="success" @click="excelExport('理发报名', '用户名、工号、部门、手机号、预约日期、预约星期、预约时间', defaultParams)">导出Excel
                </el-button>
            </template>
        </avue-crud>
    </div>
</template>
<script>
  import curd from './Base/Crud'

  export default {
    mixins: [curd],
    data() {
      return {
        url: '/activity/welfare',
        defaultParams: {type:1},  // 类型：1理发
        // curd组件
        option: {
          viewBtn: false, // 查看按钮显隐
          // menu: false,
          addBtn: false, // 增加按钮显隐
          addBtnText: '新增活动', // 新增按钮文案
          editBtn: false, // 修改按钮显隐
          delBtn: true, // 删除按钮显隐
          delBtnText: '取消报名', // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '用户名',
              prop: 'user-username',
              span: 24
            },
            {
              label: '工号',
              prop: 'user-id',
              span: 24
            },
            {
              label: '手机号',
              prop: 'user-tel',
              span: 24
            },
            {
              label: '预约日期',
              prop: 'date',
              span: 24,
              addDisplay: false,
              search: true,
              searchRange: true,
              valueFormat: 'yyyy-MM-dd',
              type: 'daterange'
            },
            {
              label: '预约星期',
              prop: 'week',
              span: 24,
              dicData: [{'label': '星期天', 'value': '0'},{'label': '星期一', 'value': '1'},{'label': '星期二', 'value': '2'},{'label': '星期三', 'value': '3'},{'label': '星期四', 'value': '4'},{'label': '星期五', 'value': '5'},{'label': '星期六', 'value': '6'}],
            },
            {
              label: '预约时间',
              prop: 'time',
              span: 24,
              dicUrl: this.getDic('activity.status')
            }
          ]
        }
      }
    },
    methods: {
      // 导出Excel文件统一处理
      excelExport(filename = new Date().getTime(), field, item) {
        console.log(item);
        this.$confirm('导出将由服务器后端执行，需要时间等待，完成后会在右上角提示下载，该导出包含以下内容: ' + field, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const message = this.$notify({
            title: '通知',
            message: '服务器处理中...',
            showClose: false,
            duration: 0
          });
          this.api.get(this.url + '/export?filename=' + filename + '&type='+item.type, this.searchParams).then((re) => {
            message.close();
            if (re.code === 0) {
              let url = this.config.baseURL + '/excel/download/' + re.data;
              this.$notify({
                title: '导出成功!',
                dangerouslyUseHTMLString: true,
                type: 'success',
                duration: 0, // 不会自动关闭的消息
                message: filename + '数据导出完成 下载导出文件:<a target="_blank" href="' + url + '">下载' + filename + 'Excel</a>'
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          });
        });
      }
    }
  }
</script>
